import analyticsService from '../helpers/analytics.service';

export const trackAddToCart = (gaData, quantity, overrides = {}) => {
    if (!gaData) return;
    analyticsService.trackAddToCart({
        id: gaData.id,
        name: gaData.name,
        productList: gaData.productList,
        quantity,
        price: gaData.price,
        accountId: gaData.accountId,
        accountType: gaData.accountType,
        ...overrides,
    });
};

export const trackRepeatOrder = (items) => {
    if (!items) return;
    analyticsService.analytics.trackRepeatOrder(items);
};

export default {trackAddToCart, trackRepeatOrder};
